import CustomApiError from './CustomApiError'

export default class CardTransactionsError extends CustomApiError {
  toDictionary () {
    return {
      CARD_TRANSACTION_ALREADY_CANCELED: 'A transação já está cancelada.',
      CARD_TRANSACTION_NOT_FOUND: 'A transação não foi encontrada.',
      CARD_TRANSACTION_REPROVED: 'A transação já está reprovada.',
      INSUFFICIENT_FUNDS: 'Saldo insuficiente.',
      ACQUIRER_CANCEL_LIMIT_EXCEEDED: 'O limite de cancelamento na adquirente foi excedido.'
    }
  }
}
